import script from "./VrpAlertModal.vue?vue&type=script&setup=true&lang=js"
export * from "./VrpAlertModal.vue?vue&type=script&setup=true&lang=js"

import "./VrpAlertModal.vue?vue&type=style&index=0&id=6618b8c2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6618b8c2"]])

export default __exports__